// Dynamic imports that survive a deploy.
//
// Vite fingerprints every chunk, so a tab that was opened before a release keeps
// asking for filenames the server no longer has. The rejection surfaces far from
// the deploy that caused it — a user clicking "Unduh PDF" hours later just sees
// "Pembuatan PDF gagal", which reads as a broken feature rather than a stale tab.
//
// Reloading picks up the current index and its current filenames. The flag makes
// that a one-shot: if the chunk is genuinely missing (a bad build), the second
// attempt rethrows instead of putting the page in a reload loop.
const RELOAD_FLAG = "landhep:chunk-reload";

const isStaleChunk = (err) => /dynamically imported module|Importing a module script failed|Failed to fetch/i
  .test(String(err?.message || err));

export async function lazyModule(load, { onStale } = {}) {
  try {
    const mod = await load();
    sessionStorage.removeItem(RELOAD_FLAG);
    return mod;
  } catch (err) {
    if (!isStaleChunk(err) || sessionStorage.getItem(RELOAD_FLAG)) throw err;
    sessionStorage.setItem(RELOAD_FLAG, "1");
    (onStale ?? ((m) => alert(m)))(
      "Aplikasi baru saja diperbarui. Halaman akan dimuat ulang — silakan ulangi setelah itu.");
    window.location.reload();
    // The reload is async; leave the caller parked so it can't report a failure
    // over the top of the message above.
    await new Promise(() => {});
  }
}
